// TODO: move global-store to shared and remove alias in tsconfig
import { useLocationStore } from '@global-store/stores/location'

export const formatPrice = (number: number, currency: string) => {
  const locationStore = useLocationStore()

  return new Intl.NumberFormat(locationStore.currentLocale, {
    style: 'currency',
    currency,
  }).format(formatPriceNumber(number))
}

export const formatPriceNumber = (number: number) => number / 100

export const i18nPrice = (price: number, currency: string): string => {
  const locationStore = useLocationStore()

  if (isNaN(price)) {
    return '999.99'
  }

  return new Intl.NumberFormat(locationStore.currentLocale, {
    style: 'currency',
    currency,
  }).format(price)
}
